import type { ComponentType, ReactNode, SVGProps } from 'react';
import styled from 'styled-components';

import { Popover, PopoverProps } from '../../cdl/Popover/Popover';
import { IconInfoSquare } from '../icons/cdl/InfoSquare';

const TriggerButton = styled.button`
    width: 16px;
    height: 16px;
    background: transparent;
    color: inherit;
    border: none;
    padding: 0;

    &:hover {
        background: transparent;
    }
`;

interface InfoPopoverProps extends Omit<PopoverProps, 'trigger'> {
    children: ReactNode;
    Icon?: ComponentType<SVGProps<SVGSVGElement>>;
    width?: string;
}

export const InfoPopover = ({
    align = 'center',
    side = 'top',
    children,
    Icon = IconInfoSquare,
    ...rest
}: InfoPopoverProps) => {
    return (
        <Popover
            align={align}
            side={side}
            {...rest}
            trigger={
                <TriggerButton
                    type="button"
                    tabIndex={-1}
                    onClick={(event) => {
                        event.stopPropagation();
                    }}
                >
                    <Icon height={16} width={16} />
                </TriggerButton>
            }
        >
            {children}
        </Popover>
    );
};
